export const ProgramRecipe = {
  template: `
    <div class="program-recipe">
      <recipe>
        <recipe-nav-left>
          <button-back>
            Week {{ $ctrl.weekNumber }}
          </button-back>
        </recipe-nav-left>
      </recipe>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/containers/Program/Recipe.js